// extracted by mini-css-extract-plugin
export default {"title":"map_title__8OzWX","content":"map_content__JmxFi","mapBox":"map_mapBox__oHIrH","map":"map_map__QDyCu","mapContainer":"map_mapContainer__nkSWI"};